const o="BRL",r="produto:geral";export{o as CURRENCY,r as GENERAL_PRODUCT};
